import { Component } from '@angular/core';

@Component({
  moduleId: module.id,
  templateUrl: 'documents.component.html',
  providers: []
})

export class DocumentsComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/documents/documents.component.ts